import { h, JSX } from 'preact';

// Inspired by Box component from MUI: https://mui.com/material-ui/react-box/

type DivProps = JSX.HTMLAttributes<HTMLDivElement>;

interface BoxProps extends DivProps {
    paddingTop?: number;
    paddingBottom?: number;
    paddingLeft?: number;
    paddingRight?: number;
}

const SCALING_FACTOR = 8;

const getStyle = (props: BoxProps): JSX.CSSProperties => {
    if (typeof props.style === 'string') {
        throw new Error('Style string is not supported by Box');
    }

    const style = (props.style ?? {}) as JSX.CSSProperties;

    if (props.paddingTop) {
        style.paddingTop = props.paddingTop * SCALING_FACTOR;
    }

    if (props.paddingBottom) {
        style.paddingBottom = props.paddingBottom * SCALING_FACTOR;
    }

    if (props.paddingLeft) {
        style.paddingLeft = props.paddingLeft * SCALING_FACTOR;
    }

    if (props.paddingRight) {
        style.paddingRight = props.paddingRight * SCALING_FACTOR;
    }

    return style;
};

const getRest = (props: BoxProps): DivProps => {
    const { paddingTop, ...rest } = props;

    return rest;
};

export const Box = (props: BoxProps): JSX.Element => (
    <div {...getRest(props)} style={getStyle(props)}>{props.children}</div>
);
